exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#intercom-container{display:none}.digit{width:15%;height:5rem;border-bottom:10px solid #96a7bb;text-align:center;margin:0 2%;transition:all .2s}@media (max-width:599px){.digit{height:3rem;border-bottom-width:7px}}.digit.entered{border-bottom-color:#f1f1f1}.digit.correct{border-bottom-color:#3fafd7}.digit.incorrect{border-bottom-color:#cf2a27}.digit p{font-weight:700;font-size:2.7rem;line-height:5rem;color:transparent;transition:all .2s}.digit p.entered{color:#f1f1f1;animation:keypadDigitAppear;animation-duration:.25s;animation-fill-mode:both}@media (max-width:599px){.digit p{font-size:1.8rem;line-height:3rem;border-bottom-width:7px}}@keyframes keypadDigitAppear{0%{opacity:0;transform:translateY(-10pt)}to{opacity:1;transform:translateY(0)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/timeclock/keypad/digit/styles.scss
// module id = 1063
// module chunks = 0